var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrapper"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../../assets/images/empty.png"),"alt":""}}),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.emptyMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }